<template>
    <div class="question-list">
        <div class="tab_bar">
            <div class="mdc-tab-bar top-tab-bar" role="tablist"  ref="questionTab">
                <div class="mdc-tab-scroller">
                    <div class="mdc-tab-scroller__scroll-area mdc-tab-scroller__scroll-area--scroll mgb-000">
                        <div class="mdc-tab-scroller__scroll-content">
                            <button v-bind:class="['mdc-tab', { 'mdc-tab--active' :tab.questionId===currentQuestion.id  || tab.questionId===currentQuestion.questionId  }]" role="tab" aria-selected="true" v-for="(tab,index) in tabs.data" v-bind:key="index" @click="!isCurrentQuestion(tab.questionId) ? moveQuestion(tab) : null">
                            <span class="mdc-tab__content">
                                <!-- <span class="mdc-tab__icon material-icons" aria-hidden="true">{{index+1}}</span> -->
                                <!-- {{tab}}
                                 {{tab.isSolve}} -->
                                <span class="mdc-tab__text-label">
                                    <div class="t-headline10" >
                                        <!-- <div :class="!tab.isSolve ? 't-color-headlineBlack': 't-line-through-gray t-color-quizBlueGray'">{{index+1}}</div> -->
                                        <div :class="!tab.isCheckButton ? 't-color-headlineBlack': 't-line-through-gray t-color-quizBlueGray'">{{index+1}}</div>
                                    </div>
                                </span>
                            </span>
                            <span v-bind:class="['mdc-tab-indicator', { 'mdc-tab-indicator--active':tab.questionId===currentQuestion.id  || tab.questionId===currentQuestion.questionId }]">
                                <span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                            <span class="mdc-tab__ripple"></span>
                        </button>
                            <!-- <div v-for="(solve, index) in solves" :key="index"> -->
                                
                            <!-- </div> -->
                            
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="divider mgt--1"></div>
    </div>
</template>

<script>
/**
 * 시험 응시 문항 네비게이션 컴포넌트(exam take question navigation component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTabBar, MDCTabBarFoundation} from '@material/tab-bar'
export default {
    props: ['solves', 'currentQuestion'],
    data() {
        return {
            questionTab: null,
            tabs : {
                currentTab : 0,
                data : this.solves
            }
            
        }
    },
    watch:{
        $route(to,from) {
            this.questionTab = new MDCTabBar(this.$refs.questionTab)
        },
        solves: function(newVal, oldVal) { // watch it
          this.questionTab = new MDCTabBar(this.$refs.questionTab)
        //console.log('this.questionTab=>watch',this.questionTab)
        }
    },
    mounted() {
        //console.log('this.solvesthis.solves',this.solves)
        this.questionTab = new MDCTabBar(this.$refs.questionTab)
        //console.log('this.questionTab',this.questionTab)
        
    },
    
    methods: {
        // 문항 이동(move question)
        setSolves(){
            this.tabs.data = this.solves
        },
        moveQuestion(solve) {
            this.$emit('selectQuestionNavi', solve)
        },
        
        isCurrentQuestion(questionId) {
            //let solvesIndex = this.solves.findIndex(element => element.questionId == this.currentQuestion.id)
            //this.solves[solvesIndex].isSolve = this.answers[this.currentQuestion.id].isSolve
            return questionId === this.currentQuestion.id
        }
    },


}
</script>